import { Input } from "@headlessui/react";
import SearchIcon from "@/assets/icons/search-lg.svg?react";
import "rsuite/DateRangePicker/styles/index.css";
import { useTranslation } from "react-i18next";

type InvoiceToBeValidatedFilterProps = {
  setSearchField: React.Dispatch<React.SetStateAction<string>>;
  searchField: string;
};

export const InvoiceToBeValidatedFilter = ({
  setSearchField,
  searchField,
}: InvoiceToBeValidatedFilterProps) => {
  const { t } = useTranslation("boInvoices");
  return (
    <div className="flex flex-col justify-start gap-2 lg:flex-row">
      <div className="flex min-w-[300px] flex-row items-center gap-3 rounded-lg border border-solid border-gray-300 bg-white px-3 py-2">
        <SearchIcon />
        <Input
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          className="w-full text-sm font-medium focus:outline-hidden"
          placeholder={t("toBeValidatedFilter.searchPlaceholder")}
        />
      </div>
    </div>
  );
};
